import { Wallet } from 'lucide-react'
import { useI18n } from '../i18n'
import { NAVY, BLUE, LIGHT_BLUE, ICE_BLUE, TEXT_MUTED } from '../pages/onboarding/onboardingPrimitives'

/**
 * SelfPayConfirmedNote — "Self-pay confirmed" + its hint, shown after "Continue without insurance" is
 * tapped and before the answer is saved. One owner for the onboarding insurance step and the
 * before-share block (PROD-1132 review MEDIUM-2): both show the same confirmation before Continue.
 */
export default function SelfPayConfirmedNote() {
  const { t } = useI18n()
  return (
    <div
      className="rounded-[14px] flex items-start gap-3"
      style={{ padding: 16, background: ICE_BLUE, border: `1.5px solid ${LIGHT_BLUE}`, marginBottom: 14 }}
      data-testid="self-pay-confirmed"
    >
      <Wallet size={22} color={BLUE} style={{ flexShrink: 0, marginTop: 1 }} />
      <div>
        <p style={{ fontSize: 14.5, fontWeight: 500, color: NAVY, marginBottom: 4 }}>
          {t('onboarding.insurance.selfPayConfirmed', 'Self-pay confirmed')}
        </p>
        <p style={{ fontSize: 13, color: TEXT_MUTED, lineHeight: 1.5 }}>
          {t('onboarding.insurance.selfPayHint', 'Doctors will see this on intake. You can add insurance anytime from your profile.')}
        </p>
      </div>
    </div>
  )
}
